import React from 'react'
import Link from 'gatsby-link'

const Header = ({ siteTitle }) => (
  <div className="container footer-box">
    <nav className="footer-nav">
      <Link to="/info/terms-conditions" className="footer-link">Terms of Use</Link>
      <Link to="/info/privacy" className="footer-link">Privacy</Link>
      <Link to="/info/careers" className="footer-link">Careers</Link>
      <Link to="/info/about-us" className="footer-link">About us</Link>
      <Link to="/contact" className="footer-link">Contact</Link>
    </nav>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/footer.js